export default __webpack_public_path__ + "static/image19-d0def50f774edab31e28d7930eeca910.jpg";